import { NextWebVitalsMetric } from 'next/app';
import Head from 'next/head';

import { MyAppProps, Config, AppProps } from '@bolttech/essentials';

export const Header = ({
  pageProps,
}: MyAppProps): JSX.Element => {
  const props = pageProps as AppProps;
  const { locale, flow, partner, fonts } = (props.config || {}) as Config;
  const flowFonts =
    fonts?.find(
      (font: { flow: string; }) =>
        font.flow === partner || font.flow === flow || font.flow === 'Direct',
    ) || ({} as Record<string, string>);

  return (
    <Head>
      <meta name="locale" content={locale} />
      <meta name="font" content={flowFonts[locale as string]} />
    </Head>
  );
};

export function reportWebVitals(metric: NextWebVitalsMetric): void {
  if (
    process.env.NODE_ENV !== 'production' &&
    process.env.LOG_WEBVITRAL_METRICS
  )
    console.log(metric);
}